import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getGridWidthClass from '../../utils/getGridWidthClass';
import { Icons, Checkbox } from '@ohif/ui-next';

const StudyListTableRow = props => {
  const { tableData } = props;
  const {
    row,
    expandedContent,
    onClickRow,
    isExpanded,
    dataCY,
    clickableCY,
    isChecked,
    onCheckboxChange,
    showCheckbox = false,
    isCritical = false,
  } = tableData;
  return (
    <>
      <tr
        className={classnames(
          'study-list-data-row select-none hover:bg-secondary-main cursor-pointer transition duration-300',
          {
            'bg-primary-dark': !isExpanded && !isCritical,
            'bg-red-900/20': !isExpanded && isCritical,
          },
          { 'bg-secondary-dark': isExpanded && !isCritical },
          { 'bg-red-900/30': isExpanded && isCritical }
        )}
        data-cy={dataCY}
        onClick={onClickRow}
      >
        <td
          className={classnames(
            'study-list-col-expand border-0 px-1 py-2 text-center align-middle',
            { 'border-secondary-light border-b': !isExpanded }
          )}
          data-cy={clickableCY}
        >
          <div className="flex items-center justify-center">
            {showCheckbox ? (
              <div
                className="mr-1 flex shrink-0 items-center justify-center"
                onClick={e => e.stopPropagation()}
              >
                <Checkbox
                  checked={isChecked || false}
                  onCheckedChange={onCheckboxChange}
                  className="data-[state=checked]:bg-primary data-[state=checked]:border-primary h-4 w-4 border-white/50"
                />
              </div>
            ) : null}
            {isExpanded ? (
              <Icons.ChevronOpen className="inline-flex" />
            ) : (
              <Icons.ChevronClosed className="inline-flex rotate-180" />
            )}
          </div>
        </td>
        {row.map((cell, index) => {
          const { content, title, gridCol, key } = cell;
          const isInstances = key === 'instances';
          return (
            <td
              key={index}
              className={classnames(
                'study-list-col border-0 px-3 py-2 text-base',
                isInstances ? 'study-list-col-instances' : 'truncate',
                { 'border-secondary-light border-b': !isExpanded },
                getGridWidthClass(gridCol) || ''
              )}
              title={title}
            >
              <div className={isInstances ? 'flex items-center whitespace-nowrap' : 'min-w-0 truncate'}>
                {content}
              </div>
            </td>
          );
        })}
      </tr>
      {isExpanded ? (
        <tr className="max-h-0 w-full select-text overflow-hidden bg-black">
          <td
            className="border-0 p-0"
            colSpan={row.length + 1}
          >
            {expandedContent}
          </td>
        </tr>
      ) : null}
    </>
  );
};

StudyListTableRow.propTypes = {
  tableData: PropTypes.shape({
    /** A table row represented by an array of "cell" objects */
    row: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        /** Optional content to render in row's cell */
        content: PropTypes.node,
        /** Title attribute to use for provided content */
        title: PropTypes.string,
        gridCol: PropTypes.number.isRequired,
      })
    ).isRequired,
    expandedContent: PropTypes.node.isRequired,
    onClickRow: PropTypes.func.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    dataCY: PropTypes.string,
    clickableCY: PropTypes.string,
    /** Whether the checkbox is checked */
    isChecked: PropTypes.bool,
    /** Callback function when checkbox state changes */
    onCheckboxChange: PropTypes.func,
    /** Whether to show the checkbox (for Technician/Admin only) */
    showCheckbox: PropTypes.bool,
    /** Whether the study is marked as critical */
    isCritical: PropTypes.bool,
  }),
};

export default StudyListTableRow;
